import React, { FC, ReactNode } from 'react';

interface FeatureIconProps {
  children: ReactNode;
}

export const FeatureIcon: FC<FeatureIconProps> = ({ children }) => {
  return (
    <div
      className="
        w-[48px] h-[48px]
        flex items-center justify-center
      ">
      {children}
    </div>
  );
};
